import createStore from '@/stores/createStore';
import { IQuickModal } from '@/utils/quickModal';

interface IConditionTimeline {
  tags: string[];
  types: string[];
}
export interface ITimelineStore {
  modal?: IQuickModal;
  conditionTimeline: IConditionTimeline;
  setModal: (modal: IQuickModal) => void;
  resetConditionTimeline: () => void;
  setConditionTimeline: (
    condition: IConditionTimeline | ((condition: IConditionTimeline) => IConditionTimeline),
  ) => void;
}

const initState = {
  modal: undefined,
  conditionTimeline: {
    types: [],
    tags: [],
  },
  setModal: function (): void {
    throw new Error('Function not implemented.');
  },
};

const useTimelineStore = createStore<ITimelineStore>((set, get) => ({
  ...initState,
  setModal(modal: IQuickModal) {
    set((s) => ({ ...s, modal: modal }));
  },
  resetConditionTimeline() {
    set((s) => ({ ...s, conditionTimeline: initState.conditionTimeline }));
  },
  setConditionTimeline(condition) {
    set((s) => ({
      ...s,
      conditionTimeline: typeof condition === 'function' ? condition(get().conditionTimeline) : condition,
    }));
  },
}));

export default useTimelineStore;
